import { FormProvider } from 'react-hook-form';
import { useCreateClientForm } from './hooks';
import { convertToPresentationProps } from './logics/convertToPresentationProps';
import { CreateClientFormPresentation } from './presentations';

/**
 * 利用企業作成フォームのコンテナコンポーネント（新版）
 *
 * NOTE: Suspense を使用する hook を含むため、親コンポーネントで Suspense でラップしてください
 */
export const CreateClientForm: React.FC = () => {
  const {
    state: {
      methods,
      isButtonDisabled,
      prefectures,
      partnerBranches,
      groups,
      clientFeatureFlags,
      partnerFeatureFlags,
    },
    actions: { handleOnSubmit, handleCancel },
  } = useCreateClientForm();

  const { prefectureOptions, partnerBranchOptions, groupOptions, featureFlagOptions } =
    convertToPresentationProps({
      prefectures,
      partnerBranches,
      groups,
      clientFeatureFlags,
      partnerFeatureFlags,
    });

  return (
    <FormProvider {...methods}>
      <CreateClientFormPresentation
        isButtonDisabled={isButtonDisabled}
        prefectureOptions={prefectureOptions}
        partnerBranchOptions={partnerBranchOptions}
        groupOptions={groupOptions}
        featureFlagOptions={featureFlagOptions}
        onSubmit={handleOnSubmit}
        onCancel={handleCancel}
      />
    </FormProvider>
  );
};
